export class TimeHelper {
	static ONE_HOUR_IN_SECONDS = 3600
	static ONE_DAY_IN_SECONDS = 86400

	static oneHour(): number {
		return TimeHelper.ONE_HOUR_IN_SECONDS
	}

	static twoHours(): number {
		return 2 * TimeHelper.ONE_HOUR_IN_SECONDS
	}

	static oneDay(): number {
		return TimeHelper.ONE_DAY_IN_SECONDS
	}

	static toSeconds(value: number, unit: "hour" | "day"): number {
		switch (unit) {
			case "hour":
				return value * TimeHelper.ONE_HOUR_IN_SECONDS
			case "day":
				return value * TimeHelper.ONE_DAY_IN_SECONDS
			default:
				throw new Error('Invalid unit. Use "hour" or "day".')
		}
	}

	static toHumanReadable(seconds: number): string {
		if (seconds < TimeHelper.ONE_HOUR_IN_SECONDS) {
			return `${seconds} seconds`
		}
		if (seconds < TimeHelper.ONE_DAY_IN_SECONDS) {
			const hours = Math.floor(seconds / TimeHelper.ONE_HOUR_IN_SECONDS)
			return `${hours} hour${hours > 1 ? "s" : ""}`
		}
		const days = Math.floor(seconds / TimeHelper.ONE_DAY_IN_SECONDS)
		return `${days} day${days > 1 ? "s" : ""}`
	}
}
